import $ from 'jquery';

export class BKMSLogger {
    static #log(message, level) {
        const data = JSON.stringify({
            context: window.location.pathname,
            level: level,
            message: message,
        });
        this.#send(data);
    }
    static #send(data) {
        $.ajax({
            type: 'POST',
            url: '/bkwebanon/action/client/clientAjaxLogger.do?method=logMessage',
            headers: { 'X-CSRF-TOKEN': csrf },
            contentType: 'application/json',
            dataType: 'json',
            data: data,
        });

        return true;
    }

    static error(message) {
        this.#log(message, 'ERROR');
    }
    static warn(message) {
        this.#log(message, 'WARN');
    }
    static info(message) {
        this.#log(message, 'INFO');
    }
}
